import { render, staticRenderFns } from "./WxLogin.vue?vue&type=template&id=39064d67&scoped=true"
import script from "./WxLogin.vue?vue&type=script&lang=js"
export * from "./WxLogin.vue?vue&type=script&lang=js"
import style0 from "./WxLogin.vue?vue&type=style&index=0&id=39064d67&prod&lang=scss&scoped=true"
import style1 from "./WxLogin.vue?vue&type=style&index=1&id=39064d67&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39064d67",
  null
  
)

export default component.exports